export const iconFontAwesomeMedicalHealthCircleRadiation = (
	<i className="fa-solid fa-circle-radiation"></i>
);
